import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

//
import { Modal, Button, Form, Spinner, Row, Col, Card } from "react-bootstrap";
import NumberFormat from "react-number-format";

//
import { getPrice } from "../../redux/features/coins/actions";
import { editTransaction } from "../../redux/features/portfolio/actions";

//
import DateSelect from "../general/DateSelect";

//
import originalMoment from "moment";
import { extendMoment } from "moment-range";

//
import { Formik } from "formik";
import * as yup from "yup";

const schema = yup.object().shape({
  quantity: yup.number().required(),
  price: yup.number().required(),
  btc_price: yup.number().required(),
});

const moment = extendMoment(originalMoment);

function EditTransactionModal({
  coins,
  show,
  setShow,
  info,
  updateTransactions,
}) {
  const [timeChangedBefore, setTimeChangedBefore] = useState(false);
  const [loading, setLoading] = useState(false);

  //
  const [timeRange, setTimeRange] = useState("");

  //
  const [initialValues, setInitialValues] = useState({
    quantity: "",
    price: "",
    btc_price: "",
  });

  /**
   * Hide Modal
   */
  const hideModal = () => {
    setTimeChangedBefore(false);
    setShow(false);
  };

  const updateValues = (e) => {
    let values = { ...initialValues };

    values[e.target.name] = e.target.value;

    setInitialValues(values);
  };

  const updatePrice = (price, key) => {
    setInitialValues((current) => {
      let values = { ...current };

      values[key] = price;

      return values;
    });
  };

  /**
   * Get Price
   */
  const get_price = async () => {
    if ((timeRange, info.symbol)) {
      if (timeChangedBefore) {
        let date = timeRange.format("YYYY-MM-DD");
        let symbol = info.symbol;

        await getPrice({ symbol, date, baseCoin: "USD" }).then((res) => {
          if (res) {
            updatePrice(res, "price");
          }
        });

        await getPrice({ symbol, date, baseCoin: "BTC" }).then((res) => {
          if (res) {
            updatePrice(res, "btc_price");
          }
        });
      } else {
        setTimeChangedBefore(true);
      }
    }
  };

  const setDefaultData = () => {
    if (show) {
      // set initial values
      let values = { ...setInitialValues };

      values.quantity = info.quantity;
      values.price = info.price;
      values.btc_price = info.btc_price;

      setInitialValues(values);

      // set time range
      setTimeRange(moment(info.date));
    }
  };

  /**
   * Edit Transaction
   */
  const edit_transaction = (e) => {
    // start loading
    setLoading(true);

    // set variables
    let id = info.id;
    let content = {
      quantity: `${e.quantity}`,
      price: `${e.price}`,
      btc_price: `${e.btc_price}`,
      date: timeRange.format("YYYY-MM-DD hh:mm"),
    };

    // request
    editTransaction({ id, content }).then((res) => {
      if (res) {
        setLoading(false);

        updateTransactions(res);

        hideModal();
      } else {
        setLoading(false);
      }
    });
  };

  useEffect(() => {
    setDefaultData();

    // eslint-disable-next-line
  }, [show]);

  useEffect(() => {
    get_price();

    // eslint-disable-next-line
  }, [timeRange]);

  return (
    <Modal
      show={show}
      onHide={() => hideModal()}
      backdrop="static"
      centered
      id="portfolio-modal"
    >
      <Modal.Header closeButton>
        <h5>Update Asset</h5>
      </Modal.Header>
      <Modal.Body>
        <Formik
          validationSchema={schema}
          enableReinitialize
          onSubmit={edit_transaction}
          initialValues={initialValues}
          className="portfolio-form"
        >
          {({ handleSubmit, handleChange, touched, errors, values }) => (
            <Form noValidate onSubmit={handleSubmit}>
              <Row>
                {/* Quantity */}
                <Col md={6}>
                  <Form.Group
                    className="form-group"
                    controlId="validationFormik02"
                  >
                    <Form.Label>Quantity</Form.Label>
                    <Form.Control
                      type="number"
                      name="quantity"
                      placeholder="0.00"
                      min="0.000000000000001"
                      step="0.000000000000001"
                      className="form-control"
                      onChange={(e) => {
                        handleChange(e);
                        updateValues(e);
                      }}
                      autoComplete="off"
                      value={values.quantity}
                      isInvalid={touched.quantity && !!errors.quantity}
                    />
                  </Form.Group>
                </Col>

                {/* Price */}

                <Col md={6}>
                  <Form.Group
                    className="form-group"
                    controlId="validationFormik03"
                  >
                    <Form.Label>Price</Form.Label>
                    <div className="input-holder left right-clear">
                      <Form.Control
                        type="number"
                        name="price"
                        placeholder="0.00"
                        min="0.01"
                        step="0.01"
                        className="form-control"
                        onChange={handleChange}
                        autoComplete="off"
                        value={values.price}
                        isInvalid={touched.price && !!errors.price}
                      />
                      <span className="text-black">$</span>
                    </div>
                  </Form.Group>
                </Col>

                {/* BTC Price */}

                <Col md={6}>
                  <Form.Group
                    className="form-group"
                    controlId="validationFormik04"
                  >
                    <Form.Label>BTC Price</Form.Label>
                    <div className="input-holder left right-clear">
                      <Form.Control
                        type="number"
                        name="btc_price"
                        placeholder="0.00000000"
                        min="0.00000001"
                        step="0.00000001"
                        className="form-control"
                        onChange={handleChange}
                        autoComplete="off"
                        value={values.btc_price}
                        isInvalid={touched.btc_price && !!errors.btc_price}
                      />
                      <span className="text-black">₿</span>
                    </div>
                  </Form.Group>
                </Col>

                <Col md={6}>
                  <Form.Group
                    className="form-group"
                    controlId="validationFormik05"
                  >
                    <Form.Label>Date</Form.Label>
                    <DateSelect
                      activeFilter={timeRange}
                      action={(item) => setTimeRange(item)}
                      icon="las la-calendar-minus"
                      fit
                      full
                    />
                  </Form.Group>
                </Col>

                <Col xs={12}>
                  <Card className="box-alert bordered mt-0">
                    <Card.Body className="flex-column align-items-start">
                      <p className="fw-bolder">Total Spent</p>

                      <h5>
                        <NumberFormat
                          value={+values.quantity * +values.price || 0}
                          displayType={"text"}
                          prefix="$"
                          thousandSeparator={true}
                          decimalSeparator="."
                        />
                      </h5>
                      <h5>
                        <NumberFormat
                          value={+values.quantity * +values.btc_price || 0}
                          displayType={"text"}
                          prefix="₿"
                          thousandSeparator={true}
                          decimalSeparator="."
                        />
                      </h5>
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
              <div className="actions">
                <div className="back" onClick={() => hideModal()}>
                  Back
                </div>

                <Button variant="info" type="submit" size="lg">
                  Update
                  {loading && (
                    <div className="spinner-holder">
                      <Spinner animation="border" variant="white" size="sm" />
                    </div>
                  )}
                </Button>
              </div>
            </Form>
          )}
        </Formik>
      </Modal.Body>
    </Modal>
  );
}

EditTransactionModal.propTypes = {
  coins: PropTypes.array.isRequired,
};

const mapStateToProps = (state) => ({
  coins: state.coinsReducer.coins,
});

export default connect(mapStateToProps)(EditTransactionModal);
